import { utils, LitElement, html } from '@hh/global.js'

const { serializeForm, fetchConfig } = utils

class HHKlaviyoForm extends LitElement {
  static properties = {
    apiVersion: {
      type: String,
      reflect: true,
      attribute: 'api-version'
    }
  }

  constructor() {
    super()

    this.form = this.querySelector('form')
    this.submitUrl = this.form.getAttribute('data-ajax-submit')
    this.formWrap = this.querySelector('.js-form-wrapper')
    this.errorHtml = this.querySelector('.js-newsletter-form-error')
    this.successHtml = this.querySelector('.js-newsletter-form-success')

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  async onSubmitHandler (event) {
    event.preventDefault()

    const formData = JSON.parse(serializeForm(this.form))

    const options = {
      method: 'POST',
      headers: {
        revision: this.apiVersion,
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: formData.email
                }
              }
            }
          },
          relationships: {list: {data: {type: 'list', id: formData.g }}}
        }
      })
    };

    const resp = await fetch(this.submitUrl, options).then(res => {
      return res.ok ? {} : res.json()
    })

    if (resp.errors) {
      this.successHtml.classList.add('hidden')
      this.errorHtml.classList.remove('hidden')
      this.errorHtml.innerHTML = resp.errors.map(err => err.detail).join('\n')
    } else {
      this.formWrap.classList.add('hidden')
      this.successHtml.classList.remove('hidden')
      this.errorHtml.classList.add('hidden')
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-klaviyo-form', HHKlaviyoForm)
